import { call, put, takeEvery } from 'redux-saga/effects';
import { HTTP_REQUEST_FAILED, HTTP_REQUEST_SUCCEEDED } from '../actions/http-requests';
import { createNotification } from '../../actions/notifications';
import { getNotificationFromPayload } from '../utils/notifications';

export const handleRequestActionCallback = (action, response) => {
  const actionSuccessCallback = (
    action &&
    action.onComplete &&
    typeof action.onComplete === 'function'
  );

  if (actionSuccessCallback && response) {
    const data = response.data || response.result;
    action.onComplete(data);
  }
};

function* handleFailNotification({ exception, requestedAction }) {
  const { error } = getNotificationFromPayload(requestedAction.payload);
  // const exceptionErrorMessage = exception && exception.message;

  if (exception && exception.status >= 500) {
    return yield put(createNotification({
      type: 'generic',
      state: 'error',
      error: {
        intlKey: 'translate.generic.notification.error.internal.server'
      }
    }));
  }

  if (error) {
    return yield put(createNotification({
      type: 'generic',
      state: 'error',
      error
    }));
  }

  if (exception && typeof exception.status !== 'number') {
    return yield put(createNotification({
      type: 'generic',
      state: 'error',
      error: {
        intlKey: 'translate.generic.notification.error'
      }
    }));
  }
}

export const handleRequestFailureCallback = (action, exception) => {
  const actionFailureCallback = (
    action &&
    action.onFailure &&
    typeof action.onFailure === 'function'
  );

  if (actionFailureCallback) {
    action.onFailure(exception);
  }
};

function* handleRequestFailed({ payload }) {
  const { requestedAction, exception } = payload;

  yield call(handleFailNotification, { exception, requestedAction });

  handleRequestFailureCallback(requestedAction, exception);
}

function* handleRequestSucceeded({ payload }) {
  const { requestedAction, response } = payload;

  const { success } = getNotificationFromPayload(requestedAction.payload);

  if (success) {
    yield put(createNotification({
      type: 'generic',
      state: 'success',
      success
    }));
  }

  handleRequestActionCallback(requestedAction, response);
}

export default function* () {
  yield takeEvery(HTTP_REQUEST_SUCCEEDED, handleRequestSucceeded);
  yield takeEvery(HTTP_REQUEST_FAILED, handleRequestFailed);
}
